export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14806.d0083e41.jpg";